export default {
  computed: {
    selectedIds: {
      get() {
        return this.form.gam_unit?.map((item) => Number(item.id))
      },
      set(ids) {
        const allOptions = this.adUnits?.flatMap((group) => group.options)

        const selected = []

        ids.forEach((id) => {
          const match = allOptions?.find((opt) => opt.id === id)
          if (!match) return

          const matchWithType = {
            id: Number(match.id),
            name: match.name,
            type: this.adUnits?.find((group) => group.options?.includes(match))?.label === 'Presets' ? 'preset' : 'adunit',
          }

          // Doar dacă nu e deja in lista
          const alreadyAdded = selected?.some((item) => Number(item.id) === Number(match.id))
          if (!alreadyAdded) {
            selected?.push(matchWithType)
          }
        })

        this.form.gam_unit = selected
      },
    },
    // selectedExpectedCreativesIds: {
    //   get() {
    //     return this.form.expected_creatives_targeting?.map((item) => Number(item.id))
    //   },
    //   set(ids) {
    //     const allOptions = this.adUnits?.flatMap((group) => group.options)

    //     const selected = [...this.form.expected_creatives_targeting] // copiem valorile existente

    //     ids.forEach((id) => {
    //       const match = allOptions?.find((opt) => opt.id === id)
    //       if (!match) return

    //       const matchWithType = {
    //         id: Number(match.id),
    //         name: match.name,
    //         type: this.adUnits?.find((group) => group.options?.includes(match))?.label === 'Presets' ? 'preset' : 'adunit',
    //       }

    //       if (matchWithType.type === 'preset') {
    //         // Elimina orice alt preset si adauga-l pe cel nou
    //         const withoutOldPresets = selected?.filter((item) => item.type !== 'preset')
    //         selected.splice(0, selected.length, ...withoutOldPresets, matchWithType)
    //       } else {
    //         // Doar dacă nu e deja in lista
    //         const alreadyAdded = selected?.some((item) => Number(item.id) === Number(match.id))
    //         if (!alreadyAdded) {
    //           selected?.push(matchWithType)
    //         }
    //       }
    //     })

    //     this.form.expected_creatives_targeting = selected
    //   },
    // },
  },
  methods: {
    clientData(form, clients, inventories) {
      const client = clients.find((c) => c.id === form.client)
      if (client && client?.user_settings) {
        const clientCpm = client?.user_settings?.cpms?.find((c) => c.publisher_id === form.inventory)
        const inventory = inventories.find((i) => i.id === form.inventory)
        const CPM = clientCpm?.cpm || Number(inventory?.user_settings?.cpm)

        return { id: form.client, clientData: client, CPM, formula: inventory?.user_settings?.impressions_formula.toLowerCase() || false }
      }

      return false
    },
    clientDataByClient(client, inventory) {
      const clientCpm = client?.user_settings?.cpms?.find((c) => c.publisher_id === inventory?.id)
      const CPM = clientCpm?.cpm || inventory?.user_settings?.cpm

      return {
        client: { id: client.id, clientData: client, CPM, formula: inventory?.user_settings?.impressions_formula?.toLowerCase() || false },
      }
    },
    isClientAuthorized() {
      if (this.$canAccess(['brand-admin', 'brand-employee', 'agency-client'])) {
        const user = this.$store.state.user
        const isBrandAdmin = user.type === 'brand-admin' || user.type === 'agency-client'

        if (isBrandAdmin) {
          this.form.client = user.id
          this.clients = [
            {
              id: user.id,
              name: user.name,
              user_settings: { cpms: this.userCpms },
            },
          ]
        } else {
          const parentUser = user.parent_user
          this.form.client = parentUser.id
          this.clients = [
            {
              id: parentUser.id,
              name: parentUser.name,
              user_settings: { cpms: parentUser.cpms },
            },
          ]
        }
        return true
      } else {
        return false
      }
    },
    removeQueryParameter(param) {
      const query = { ...this.$route.query }
      delete query[param]

      this.$router.replace({ query })
    },
    async updateStoreFormDetails(pageLoading = true) {
      const res = await this.$store.dispatch('socialBoostCampaign/getCampaign', {
        id: this.$route.params.id || this.$route.query.campaign,
        pageLoading,
      })
      // const isUnitSet = this.$store.getters['socialBoostCampaign/adUnits']
      // if (!isUnitSet) {
      //   await this.$store.dispatch('socialBoostCampaign/getAdUnits')
      // }
      if (res) {
        const campaignData = this.clientDataByClient(res.client, res.publisher)
        campaignData.name = res.name
        campaignData.inventory = res.publisher_id
        campaignData.mediaPlanFiles = res.media_plan
        campaignData.observations = res.observations
        campaignData.is_simple = this.$route.params.type === 'simple'

        this.$store.commit('socialBoostCampaign/SET_CAMPAIGN_FORM', { section: 'details', data: campaignData })
        if (res.flights && res.flights?.length > 0 && campaignData.is_simple) {
          const flight = res.flights[0]
          if (flight) {
            this.$store.commit('socialBoostCampaign/SET_FLIGHT', flight)
          }
        }
      }
    },
  },
}
